import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  standalone: false
})
export class MessageComponent {

  @ViewChild('messageContainer') private messageContainer!: ElementRef;

  @Input() message?: { sender: 'user' | 'ai', content: string, pending: boolean };

  constructor() {}

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.messageContainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
